<style lang="less" scoped>
  .contain {
    padding: 10px;
  }
  .p-c {
    padding: 0px 0 5px;
    margin: 0px;
    span:first-child {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
  }
</style>
<template>
  <div
    class="text-center align-center justify-space-around"
    :style="`display:inline;`"
  >
    <v-tooltip
      :right="right"
      :top="top"
      color="rgb(45, 43, 43)"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          text
          :style="`padding:0px;min-width:${minWidth}px`"
          v-on="on"
        >
          <slot />
        </v-btn>
      </template>
      <!-- style="background: black;" -->
      <div class="contain">
        <Content :render="render" />
        <!-- <p class="p-c">
          <span>博主昵称</span>：<span>{{ value.platform_nickname }}</span>
        </p>
        <p class="p-c">
          <span>博主平台号</span>：<span>{{ value.platform_account }}</span>
        </p>
        <p class="p-c">
          <span>博主粉丝量</span>：<span>{{ value.fans_amount }}</span>
        </p> -->
      </div>
    </v-tooltip>
  </div>
</template>
<script>
  const Content = {
    props: {
      render: {
        type: Function,
        default: () => () => {}
      },
    
    },
    render(h) {
      console.log()
      return this.render(h)
    }
  }

  export default {
  
    components: {
      Content,
    },
    props: {
      minWidth: {
        type:Number,
  
      },
      top: {
        type: Boolean,
        default: false
      },
      right: {
        type: Boolean,
        default: false
      },
      
      render: {
        type: Function,
        default: () => () => {}
      }, 
      value: {
        type: Object,
        default:() => ({})
      },
     
    }
  }
</script>